import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";

import { supabase } from "@/integrations/supabase/client";
import { Logo, PAGE_CONTAINER } from "../components/site";

export const Route = createFileRoute("/admin_/inloggen")({
  head: () => ({
    meta: [
      { title: "Admin inloggen | offerto" },
      { name: "description", content: "Inlogportaal voor beheerders van offerto." },
      { property: "og:title", content: "Admin inloggen | offerto" },
      { property: "og:description", content: "Inlogportaal voor beheerders van offerto." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: AdminInloggen,
});

function AdminInloggen() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [wachtwoord, setWachtwoord] = useState("");
  const [bezig, setBezig] = useState(false);
  const [fout, setFout] = useState("");

  async function onLogin(e: React.FormEvent) {
    e.preventDefault();
    setBezig(true);
    setFout("");
    const { data, error } = await supabase.auth.signInWithPassword({ email: email.trim(), password: wachtwoord });
    if (error || !data.user) {
      setBezig(false);
      setFout("Inloggen mislukt. Controleer je e-mailadres en wachtwoord.");
      return;
    }
    const { data: rol } = await supabase.rpc("has_role", { _user_id: data.user.id, _role: "admin" });
    setBezig(false);
    if (rol !== true) {
      await supabase.auth.signOut();
      setFout("Dit account heeft geen beheerdersrechten.");
      return;
    }
    void navigate({ to: "/dashboard" });
  }

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <header className="border-b border-border">
        <div className={`${PAGE_CONTAINER} py-5`}><Logo /></div>
      </header>
      <main className="mx-auto flex w-full max-w-md flex-1 flex-col justify-center px-4 py-16">
        <h1 className="text-2xl font-bold">Admin inloggen</h1>
        <p className="mt-2 text-sm text-muted-foreground">Log in om het dashboard met bezoekers en aanvragen te bekijken.</p>
        <form onSubmit={(e) => void onLogin(e)} className="mt-8 space-y-5">
          <label className="block">
            <span className="text-sm font-bold">E-mailadres</span>
            <input type="email" required autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-2 h-12 w-full rounded-md border border-input px-4 text-base outline-none focus:border-primary" />
          </label>
          <label className="block">
            <span className="text-sm font-bold">Wachtwoord</span>
            <input type="password" required autoComplete="current-password" value={wachtwoord} onChange={(e) => setWachtwoord(e.target.value)}
              className="mt-2 h-12 w-full rounded-md border border-input px-4 text-base outline-none focus:border-primary" />
          </label>
          {fout && <p className="text-sm font-medium text-destructive">{fout}</p>}
          <button type="submit" disabled={bezig} className="w-full rounded-md bg-primary px-6 py-3 font-bold text-primary-foreground disabled:opacity-40">
            {bezig ? "Bezig…" : "Inloggen"}
          </button>
        </form>
      </main>
    </div>
  );
}
